import Button from '@nebula/button';
import { TitleSmall500 } from '@nebula/global-styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ isWebview }) => (isWebview ? '100vh' : '80vh')};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    justify-content: unset;
    height: 641px;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: 802px;
    margin: 0 auto;
    justify-content: unset;
    height: 713px;
  }

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    justify-content: unset;
    height: 641px;
  }
`;

export const InfoContainer = styled.div`
  padding: 24px 16px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 24px 24px 0 24px;
  }
`;

export const StyledTitleSmall500 = styled(TitleSmall500)`
  margin-top: 16px;
  font-size: 16px;
  line-height: 24px;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  padding: 16px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex-direction: row;
    gap: 16px;
  }
`;

export const CancelButton = styled(Button)`
  background-color: ${({ theme }) => theme.color.decorative.magenta[70]} !important;
  border: none;
  font-size: 14px;
  line-height: 20px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: 16px;
    line-height: 24px;
    order: 2;
  }
`;

export const KeepButton = styled(Button)`
  color: ${({ theme }) => theme.color.decorative.magenta[70]};
  background-color: white;
  font-size: 14px;
  line-height: 20px;
  border: 2px solid ${({ theme }) => theme.color.decorative.magenta[70]};

  &:hover {
    background-color: white;
    border-color: ${({ theme }) => theme.color.decorative.magenta[70]};
    color: ${({ theme }) => theme.color.decorative.magenta[70]};
  }

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: 16px;
    line-height: 24px;
    order: 1;
  }
`;
